import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const [sp] = useSearchParams();
  const bookingId = sp.get("b");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!bookingId) { setStatus("error"); return; }
    (async () => {
      try {
        await api.post(`/bookings/${bookingId}/unsubscribe`);
        setStatus("done");
      } catch {
        setStatus("error");
      }
    })();
  }, [bookingId]);

  return (
    <div className="section">
      <div className="mx-auto max-w-xl text-center card-soft p-10">
        {status === "loading" && <Loader2 className="h-8 w-8 mx-auto animate-spin text-pebble" />}
        {status === "done" && (
          <>
            <div className="h-14 w-14 mx-auto rounded-full bg-champagne flex items-center justify-center">
              <Check className="h-7 w-7 text-charcoal" />
            </div>
            <div className="overline mt-6">Preferences updated</div>
            <h1 className="h-display mt-3 text-3xl">You're unsubscribed.</h1>
            <p className="mt-3 text-graphite text-sm">We won't send you any more booking reminders. You'll still receive receipts and confirmation emails for any active reservation.</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className="overline">Something went wrong</div>
            <h1 className="h-display mt-3 text-3xl">We couldn't find that link.</h1>
            <p className="mt-3 text-graphite text-sm">If you're still receiving reminders you'd rather not, email us at info@southernutaheventrentals.com and we'll take care of it.</p>
          </>
        )}
      </div>
    </div>
  );
}
